export default __webpack_public_path__ + "static/media/icons-mute.9dc1a630.svg";